// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__KJgT-","logo":"Navbar_logo__KL+Ba","mobileMenuLinks":"Navbar_mobileMenuLinks__Gnism"};